import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { AppFacade } from 'ish-core/facades/app.facade';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';

import { DotCmsPageContextFacade } from '../../../facades/dot-cms-page-context.facade';
import { CustomDotPageAssetLayoutBody } from '../../../models/page/custom-dot-cms-page.model';

@Component({
  selector: 'custom-dot-cms-layout-grid',
  templateUrl: './dot-cms-layout-grid.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DotCmsLayoutGridComponent implements OnInit, OnDestroy {
  pageLayoutBody$: Observable<CustomDotPageAssetLayoutBody>;
  deviceType$: Observable<DeviceType>;
  private destroy$ = new Subject<void>();

  constructor(private context: DotCmsPageContextFacade, private appFacade: AppFacade) {}

  ngOnInit(): void {
    this.deviceType$ = this.appFacade.deviceType$;
    this.pageLayoutBody$ = this.context.getPageLayoutBody$();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
